import { Typography } from '@mui/material';

export interface FieldErrorProps {
  error?: string[] | string | null;
}

export const FieldError = ({ error }: FieldErrorProps) => {
  if (!error) return null;

  const errors = Array.isArray(error) ? error : [error];

  return errors.map((error, index) => (
    <Typography
      key={`${error}-${index}`}
      sx={{ color: 'error.main', fontSize: '12px' }}
    >
      {error}
    </Typography>
  ));
};
